import { supabase } from "@/integrations/supabase/client";

export interface Organization {
  id: string;
  name: string;
  slug: string;
}

export const loadOrganizations = async (): Promise<Organization[]> => {
  const { data, error } = await supabase
    .from("organizations")
    .select("id, name, slug")
    .order("name");
  if (error) {
    console.error("Error loading organizations:", error);
    return [];
  }
  return (data || []) as Organization[];
};

export const createOrganization = async (
  name: string,
  slug: string,
): Promise<{ data?: Organization; error?: string }> => {
  const { data, error } = await supabase
    .from("organizations")
    .insert({ name: name.trim(), slug: slug.trim().toLowerCase() } as any)
    .select("id, name, slug")
    .single();
  if (error) return { error: error.message };
  return { data: data as Organization };
};

export const updateUserOrganization = async (
  userId: string,
  organizationId: string,
): Promise<{ error?: string }> => {
  const { error } = await supabase
    .from("profiles")
    .update({ organization_id: organizationId } as any)
    .eq("id", userId);
  return { error: error?.message };
};

export const updateCompanyOrganization = async (
  companyId: string,
  organizationId: string,
): Promise<{ error?: string }> => {
  const { error } = await supabase
    .from("company_masters")
    .update({ organization_id: organizationId } as any)
    .eq("id", companyId);
  return { error: error?.message };
};

// ── Ajustes de traspaso SUENLACE por asesoría ────────────────────────────
export interface OrgExportSettings {
  useInvoiceDateAsEntryDate: boolean;
  omitVatLedgerNumber: boolean;
}

export const DEFAULT_ORG_EXPORT_SETTINGS: OrgExportSettings = {
  useInvoiceDateAsEntryDate: false,
  omitVatLedgerNumber: false,
};

export const loadOrganizationExportSettings = async (
  organizationId: string,
): Promise<OrgExportSettings> => {
  const { data, error } = await supabase
    .from("organizations")
    .select("suenlace_use_invoice_date, suenlace_omit_vat_ledger_number")
    .eq("id", organizationId)
    .maybeSingle();
  if (error || !data) return { ...DEFAULT_ORG_EXPORT_SETTINGS };
  return {
    useInvoiceDateAsEntryDate: !!(data as any).suenlace_use_invoice_date,
    omitVatLedgerNumber: !!(data as any).suenlace_omit_vat_ledger_number,
  };
};

export const updateOrganizationExportSettings = async (
  organizationId: string,
  settings: Partial<OrgExportSettings>,
): Promise<{ error?: string }> => {
  const patch: Record<string, boolean> = {};
  if (settings.useInvoiceDateAsEntryDate !== undefined)
    patch.suenlace_use_invoice_date = settings.useInvoiceDateAsEntryDate;
  if (settings.omitVatLedgerNumber !== undefined)
    patch.suenlace_omit_vat_ledger_number = settings.omitVatLedgerNumber;
  const { error } = await supabase
    .from("organizations")
    .update(patch as any)
    .eq("id", organizationId);
  return { error: error?.message };
};
